import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import {
  IPaymentCheckoutSession,
  IPaymentDetailsData,
  TCheckoutSessionPayload,
} from '@/types';
import { ITemplateResponse } from '@/types/common';

class PaymentsApi extends AbortControllerManager {
  private readonly PAYMENTS_URL = '/v2/payments';

  constructor() {
    super();
  }

  getPayment(id: string): Promise<ITemplateResponse<IPaymentDetailsData>> {
    const signal = this.createAbortController(`getPayment-${id}`);
    return authClient.get(`${this.PAYMENTS_URL}/${id}`, { signal });
  }

  checkoutSession(
    id: string,
    payload: TCheckoutSessionPayload = {},
  ): Promise<ITemplateResponse<IPaymentCheckoutSession>> {
    const signal = this.createAbortController(`checkoutSession-${id}`);
    return authClient.post(
      `${this.PAYMENTS_URL}/${id}/checkout-session`,
      payload,
      {
        signal,
      },
    );
  }
}

export const paymentsApi = new PaymentsApi();
